/* eslint-disable react-hooks/exhaustive-deps */
import DataIsReprocessingBar from 'components/ReusableComponents/DataIsReprocessingBar'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import { getReviewRequests } from '../../actions/reviews'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import SmartDatepicker from '../../components/ReusableComponents/SmartDatepicker'
import ReviewDetails from './ReviewDetails'
import Row from './ReviewRow'
import styles from './Reviews.module.scss'
import Sidebar from './Sidebar'

const Reviews = () => {
  const { date } = useParams()

  const { dailySummaries, latestDetails, isLoading, error } = useSelector(s => s.reviews)

  const [startDate, setStartDate] = useState(moment().startOf('day').subtract(14, 'days'))
  const [endDate, setEndDate] = useState(moment().startOf('day'))

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      getReviewRequests(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'))
    )
  }, [startDate, endDate])

  return (
    <div className={styles.wrapper}>
      <CustomHeader title="Review ratings" width={1000} />
      <hgroup className={styles.hgroup}>
        <SmartDatepicker
          startDate={startDate}
          endDate={endDate}
          isRange={true}
          className={styles.datepicker}
          onChangeStartDate={date => setStartDate(date)}
          onChangeEndDate={date => setEndDate(date)}
        />
      </hgroup>
      <DataIsReprocessingBar marginBottom={20} />
      <div className={styles.container}>
        <div className={styles.rows}>
          {error && (
            <div className={styles.noResults}>
              Something went wrong while getting results
            </div>
          )}
          {isLoading ? (
            <LoadingIndicator />
          ) : dailySummaries.length ? (
            <>
              {dailySummaries.map((reviewReq, i) => (
                <Row {...reviewReq} key={i} />
              ))}
              <div className={styles.footnote}>
                <InfoIcon /> Guests with mobile numbers whom are eligible for reviews
              </div>
            </>
          ) : (
            <div className={styles.noResults}>No results found for this date range</div>
          )}
        </div>
        {!isLoading && latestDetails.length > 0 && <Sidebar data={latestDetails} />}
        {date && <ReviewDetails />}
      </div>
    </div>
  )
}

export default Reviews
